<template>
  <a-modal 
    :visible="visible" 
    :title="title" 
    :width="750"
    @cancel="onCancel"
    @ok="onSave"
    cancelText="取消" okText="确认">
    <a-form :form="edit_item">
      <a-row :gutter="10">
        <a-col :span="8">
          <a-form-item label="牧场名称">
            <a-input v-model="edit_item.name" class="width-100"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="10">
        <a-col :span="8">
          <a-form-item label="地址">
            <a-input v-model="edit_item.location" class="width-100"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="8">
          <a-form-item label="负责人">
            <user-select @finish-select="on_user_select"></user-select>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>

<script>
import userSelect from '../../users/components/userSelect.vue'
export default {
  name: "breedItemEdit",
  components: {
    userSelect
  },
  data() {
    return {
      action: '',
      edit_item: {},
      edit_item_template: {
        name: '',
        location: '',
        phone: '',
        user_id: ''
      },
      visible: false,
      title: ''
    }
  },
  methods: {
    open(action, item) {
      let _self = this
      this.action = action
      if (action == 'add') {
        this.title = '新增牧场'
        this.edit_item = JSON.parse(JSON.stringify(this.edit_item_template))
      } else {
        this.title = '编辑牧场'
        this.edit_item = item
      }
      this.visible = true
    },
    onCancel() {
      this.visible = false
    },
    onSave() {
      // 清理空值，将空字符串转为 null
      const submitData = { ...this.edit_item };
      if (submitData.user_id === '' || submitData.user_id === undefined) {
        submitData.user_id = null;
      }
      if (submitData.phone === '') {
        submitData.phone = null;
      }
      
      if (this.action == 'add') {
        this.$api.post_farm(submitData).then(res =>  {
          if (res.code == 200) {
            this.$message.success("保存成功");
            this.visible = false
            this.edit_item = JSON.parse(JSON.stringify(this.edit_item_template))
            this.$emit('finish-edit')
          }
        })
      } else {
        this.$api.put_farm(submitData).then(res =>  {
          if (res.code == 200) {
            this.$message.success("保存成功");
            this.visible = false
            this.edit_item = JSON.parse(JSON.stringify(this.edit_item_template))
            this.$emit('finish-edit')
          }
        })
      }
    },
    on_user_select(user_id) {
      this.edit_item.user_id = user_id
    },
  },
}
</script>

<style>
</style>